import {
    Badge, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger,
    VStack,
} from '@chakra-ui/react';
import React, { ComponentProps } from 'react';

function PopoverTag({
    popoverPlacement = 'auto',
    children,
    colorScheme,
    title,
    badgeSize,
    badgeVariant,
    ...props
}: {
    children?: React.ReactNode;
    popoverPlacement: ComponentProps<typeof Popover>['placement'];
    colorScheme: ComponentProps<typeof Badge>['colorScheme'];
    title: React.ReactNode;
    badgeSize?: ComponentProps<typeof Badge>['size'];
    badgeVariant?: ComponentProps<typeof Badge>['variant'];
} & ComponentProps<typeof Popover>) {
    if (React.Children.count(children) === 0) {
        return <Badge colorScheme={colorScheme} userSelect="none">{title}</Badge>;
    }

    return (
        <Popover isLazy trigger="hover" placement={popoverPlacement} {...props}>
            <PopoverTrigger>
                <Badge
                    colorScheme={colorScheme}
                    size={badgeSize}
                    variant={badgeVariant}
                    cursor="pointer"
                    userSelect="none"
                >
                    {title}
                </Badge>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverBody>
                    <VStack alignItems="flex-start" gap={0}>
                        { children }
                    </VStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export { PopoverTag };
